import React from "react";
import { HeaderContainer } from "./Sections.styles";

const Header = props => {
  return (
    <HeaderContainer>
      <h1>Leigh-Ann Friedel</h1>
    </HeaderContainer>
  );
};

export default Header;
